import React from 'react'
import { CButton } from '@coreui/react'

const Button = (props) => {
  return (
    <>{(props.type === 'dark') ?
      <CButton color="dark " className="btn mt-4 " style={{ background: "#1b2330" }} disabled={props.loading} onClick={props.onClick}>
        {props.loading ? <span className="spinner-border spinner-border-sm"></span> : <span>{props.text}</span>}
      </CButton>
      :
      <CButton color="secondary" className="float-left btn-light mt-4  mr-3" onClick={props.onClick}>{props.text}</CButton>
    }
    </>
  )
}

export default Button;